export function resolveWithdrawExtsContext(source) {
  if (!source) {
    return { currency: '', payType: '' }
  }
  const wo = source.withdrawOrder || source
  return {
    currency: String(source.currency || wo.currency || '').toUpperCase(),
    payType: String(source.payType || source.type || wo.payType || '').toLowerCase()
  }
}

export function getWithdrawExtsLabel(source) {
  const { currency, payType } = resolveWithdrawExtsContext(source)
  if (currency === 'JOD' && payType === 'bank') {
    return 'SWIFT Code'
  }
  return 'IBAN'
}

export function shouldShowWithdrawExts(item) {
  const wo = item?.withdrawOrder
  if (!wo?.exts) {
    return false
  }
  const { currency, payType } = resolveWithdrawExtsContext(item)
  if (currency === 'JOD' && payType === 'bank') {
    return true
  }
  if (payType === 'stcpay' || payType === 'aani') {
    return true
  }
  if ((payType === 'barq' || payType === 'urpay') && Number(item?.payAmount) >= 300) {
    return true
  }
  return false
}
